import { browser } from '$app/environment';
import { cookieConsent } from '$lib/cookieConsent.svelte.js';
import { analytics } from '$lib/analytics.svelte.js';

const artWork = `

              ░▓█████████████████████▓░
            ▓███████▓░░░░░░░▓████████████
          ▓███████▓           ░▓██████████▓
        ▓████████░              ░███████████░
      ░█████████░                 ███████████░
      █████████▓                  ░███████████
    ██████████                    ░███████████
    █████████▓                     ▓██████████
    ░█████████░                     ░██████████░
    ░█████████░                     ░██████████░
    ░█████████░                      ██████████░
    ░█████████▓                      ▓█████████░
    ░██████████                      ▓█████████░
    ░██████████▓                     ██████████
    ███████████░                   ▓█████████▓
    ░███████████░                  ██████████
      ░███████████                 ▓█████████░
      ░███████████░              ▓████████▓
        ▓██████████▓           ▓████████▓
          ▓███████████▓░░░░░░▓████████▓
            ░▓████████████████████▓░░
                ░░░░░░░░░░░░░░░░░░


  ╭―――――――――― Welcome to ORDALIE.TECH ―――――――――――╮
  │                                              │
  │ If you're interested in helping us build the │
  │ future of legal AI, head to ordalie.ai/join  │
  │                                              │
  ╰――――――――――――――――――――――――――――――――――――――――――――――╯


`;

export const load = async () => {
	if (browser && !window.location.hostname.includes('localhost')) {
		console.log(artWork);
	}

	// Initialize analytics only if user has given consent
	if (browser && cookieConsent.hasAnalyticsConsent) {
		analytics.initPostHog();
	}
	return;
};
